import * as _ from 'lodash';
import { ASSET_TYPES } from '../../../HelperMethods/enums';
import { getMappedEntityChanges } from '../../../HelperMethods/UtilityFunctions';
import { AREA_TYPE } from '../../taskSetup/AreaSetup/constants';

export const userInsertOrUpdate = (usersList, user) => {
  const userIndex = usersList.findIndex((u) => u.id === user.id);
  if (userIndex > -1) {
    usersList.splice(userIndex, 1, user);
  } else {
    usersList.push(user);
  }
};
export const uniqueString = () => {
  return Date.now();
};

export const UserSchema = () => {
  return {
    firstName: '',
    lastName: '',
    userName: '',
    email: '',
    fieldName: '',
    fieldId: '',
    password: '',
    hitchPattern: [],
    offDays: [],
    onDays: [],
    joyn2Roles: [],
    hitchStartDate: null,
    aclQualifiedId: null,
    approver: { enabled: false, rows: [] },
    businessTitle: null,
    vendorId: null,
    areaNames: [],
    teamNames: '',
    certificates: [],
    mobileSettings: {
      assetTypesToDownload: Object.values(ASSET_TYPES).map((val) => val.value),
    },
  };
};

export const firstNamecellStyle = (params) => {
  if (params.data.comments.includes('firstname') || params.data.comments.includes('firstName'))
    return {
      backgroundColor: '#FEFDD7',
      border: '1px solid  #F3775B',
    };

  return {
    backgroundColor: 'transparent',
  };
};
export const lastnamecellStyle = (params) => {
  if (params.data.comments.includes('lastname') || params.data.comments.includes('lastName'))
    return {
      backgroundColor: '#FEFDD7',
      border: '1px solid  #F3775B',
    };

  return {
    backgroundColor: 'transparent',
  };
};
export const passwordcellStyle = (params) => {
  if (params.data.comments.includes('Password') || params.data.comments.includes('password'))
    return {
      backgroundColor: '#FEFDD7',
    };

  return {
    backgroundColor: 'transparent',
  };
};
export const emailcellStyle = (params) => {
  if (params.data.comments.includes('email'))
    return {
      backgroundColor: '#FEFDD7',
      border: '1px solid  #F3775B',
    };

  return {
    backgroundColor: 'transparent',
  };
};
export const usernamecellStyle = (params) => {
  if (
    params.data.comments.includes('userName') ||
    params.data.comments.includes('username') ||
    params.data.comments.includes('Username')
  )
    return {
      backgroundColor: '#FEFDD7',
      border: '1px solid  #F3775B',
    };

  if (params.data.comments.includes('FAILURE'))
    return {
      backgroundColor: '#FEFDD7',
      border: '1px solid  #F3775B',
    };

  return {
    backgroundColor: 'transparent',
  };
};
export const fieldnamecellStyle = (params) => {
  if (params.data.comments.includes('fieldname') || params.data.comments.includes('fieldName'))
    return {
      backgroundColor: '#FEFDD7',
      border: '1px solid  #F3775B',
    };

  return {
    backgroundColor: 'transparent',
  };
};

export const regexString = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[\^$*.[\]{}()?\-"!@#%&/,><':;|_~`])\S{8,99}$/;

export const validationFields = (fieldsArray, correctKeys, fieldsDict, allowedFieldsname) => {
  const OutputObj = [];
  const userNamearray = [];

  fieldsArray.forEach((fieldObj) => {
    let Comment = '';
    const newOBJ = {};
    correctKeys.forEach((Keys) => {
      if (fieldObj[Keys]) {
        switch (Keys) {
          case 'firstName':
            newOBJ[Keys] = fieldObj[Keys];

            if (_.isEmpty(fieldObj[Keys])) {
              Comment += ' firstname is empty';
            }
            break;
          case 'lastName':
            newOBJ[Keys] = fieldObj[Keys];
            if (_.isEmpty(fieldObj[Keys])) {
              Comment += ' lastname is empty';
            }
            break;

          case 'fieldName':
            newOBJ[Keys] = fieldObj[Keys];

            if (!_.isEmpty(fieldObj[Keys]) && allowedFieldsname(fieldsDict).indexOf(fieldObj[Keys]) === -1) {
              Comment += ' fieldname not allowed';
            }

            break;
          case 'password':
            newOBJ[Keys] = fieldObj[Keys];

            if (!regexString.test(fieldObj[Keys])) {
              Comment +=
                ' Password should contain 8-16 character, one special character,one capital letter and atleast one number';

              if (_.isEmpty(fieldObj[Keys])) {
                Comment += ' password is empty';
                break;
              }
            } else if (fieldObj[Keys] && fieldObj[Keys].length > 16) {
              Comment +=
                ' Password should contain 8-16 character, one special character,one capital letter and atleast one number';
            }
            break;

          case 'email':
            newOBJ[Keys] = fieldObj[Keys];

            if (
              !/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
                fieldObj.email
              )
            ) {
              Comment += ' not a valid email';
              if (_.isEmpty(fieldObj[Keys])) {
                Comment += ' email is empty';
                break;
              }
            }
            break;

          case 'userName':
            newOBJ[Keys] = fieldObj[Keys];
            if (
              !/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
                fieldObj[Keys]
              )
            ) {
              Comment += ' not a valid username';

              if (_.isEmpty(fieldObj[Keys])) {
                Comment += ' username is empty';

                break;
              }
            } else {
              if (userNamearray.findIndex((x) => x === fieldObj[Keys]) !== -1) {
                Comment += ' username is not unique';
              } else {
                userNamearray.push(fieldObj[Keys]);
              }
              break;
            }
            break;
          default:
        }
      }
    });

    if (Object.keys(newOBJ).length !== correctKeys.length) {
      const difference = _.difference(correctKeys, Object.keys(newOBJ));
      difference.forEach((DifferenceItem) => {
        if (DifferenceItem !== 'fieldName') Comment += ` ${DifferenceItem} is empty`;
      });
    }

    if (!_.isEmpty(newOBJ)) {
      OutputObj.push({ ...newOBJ, comments: Comment });
    }
  });
  return OutputObj;
};

const areaDefinitionHelper = (area) => {
  const { areaDefinition = {} } = area;
  const clonedAreaDefinition = JSON.parse(JSON.stringify(areaDefinition));
  const { criteria = [] } = clonedAreaDefinition;
  for (const areaCriteria of criteria || []) {
    const { values = [], attributeName = '' } = areaCriteria;
    if (attributeName === 'Route') {
      areaCriteria.values = { id: (values || []).join(',') };
    } else {
      areaCriteria.values = { values: (values || []).join('|') };
    }
  }
  return clonedAreaDefinition;
};

const resourceLevelDict = { PRIMARY: 'primary', SECONDARY: 'secondary' };

const userObjByType = {
  [resourceLevelDict.PRIMARY]: (userId) => {
    return { resourceLevel: resourceLevelDict.PRIMARY, userId, isDeleted: false };
  },
  [resourceLevelDict.SECONDARY]: (userId) => {
    return {
      resourceLevel: resourceLevelDict.SECONDARY,
      userId,
      isDeleted: false,
    };
  },
};

const updateResourceForDeletedAreaMapping = ({ deletedAreaIds, areasDict, initialAreaTeamMapping, userId }) => {
  const areaToBeUpdated = [];
  for (const areaId of deletedAreaIds) {
    const reqArea = JSON.parse(JSON.stringify(areasDict[areaId] || {}));
    for (const resourceLevel of Object.values(resourceLevelDict)) {
      const reqAreaMapping = initialAreaTeamMapping[areaId]?.[resourceLevel];
      if (reqAreaMapping) {
        const teamsMappedToArea = reqArea?.teams ?? [];
        console.log('deleted areas teamsMappedToArea', teamsMappedToArea);
        const teamsToUpdate = teamsMappedToArea.map((team) => {
          if (!team.isDeleted) {
            const reqResources = (team?.resources || [])
              ?.filter((resource) => resource.userId === userId && resource.resourceLevel === resourceLevel)
              .map((val) => {
                return { ...val, isDeleted: true };
              });
            team.resources = [
              ...(team?.resources || []).filter(
                (resource) => !(resource.userId === userId && resource.resourceLevel === resourceLevel)
              ),
              ...reqResources,
            ];
          }
          return team;
        });
        reqArea.teams = teamsToUpdate;
      }
    }
    const areaObj = { id: areaId, areaType: reqArea.areaType, teams: reqArea.teams, type: reqArea.type };
    if (areaObj.areaType === AREA_TYPE.DYNAMIC) {
      const structuredAreaDefinition = areaDefinitionHelper(reqArea);
      areaObj.areaDefinition = structuredAreaDefinition;
    }
    areaToBeUpdated.push(areaObj);
  }
  return areaToBeUpdated;
};

const updateResourcesForExistingAreaMapping = ({ areaTeamMapping, areasDict, initialAreaTeamMapping, userId }) => {
  const areaToBeUpdated = [];
  Object.keys(areaTeamMapping || {}).forEach((areaId) => {
    const reqArea = areasDict[areaId];
    const teamsMappedToArea = JSON.parse(JSON.stringify(reqArea?.teams ?? []));
    const teamsToBeMapped = areaTeamMapping[areaId] ?? {};
    const initialTeamsMapped = initialAreaTeamMapping[areaId] ?? {};
    for (const resourceLevel of Object.values(resourceLevelDict)) {
      const teamsMappedToAreaDict = _.keyBy(teamsMappedToArea, 'teamId');
      const teamsMappedToResourceType = teamsToBeMapped?.[resourceLevel] ?? [];
      const initialTeamsMappedToResourceType = initialTeamsMapped?.[resourceLevel] ?? [];
      const { deleted } = getMappedEntityChanges(teamsMappedToResourceType, initialTeamsMappedToResourceType);
      for (const teamId of deleted) {
        const reqTeam = teamsMappedToAreaDict[teamId];
        if (reqTeam) {
          reqTeam.isDeleted = false;
          const reqResources = (reqTeam?.resources || [])
            ?.filter((resource) => resource.userId === userId && resource.resourceLevel === resourceLevel)
            .map((val) => {
              return { ...val, isDeleted: true };
            });
          reqTeam.resources = [
            ...reqTeam?.resources?.filter(
              (resource) => !(resource.userId === userId && resource.resourceLevel === resourceLevel)
            ),
            ...reqResources,
          ];
        }
      }

      for (const teamId of teamsMappedToResourceType) {
        const reqTeam = teamsMappedToAreaDict[teamId];
        if (!reqTeam) {
          const teamResourceObj = {
            teamId,
            resources: [userObjByType[resourceLevel](userId)],
          };
          teamsMappedToArea.push(teamResourceObj);
        } else if (reqTeam) {
          reqTeam.isDeleted = false;
          const resourceList = (reqTeam?.resources || [])?.filter(
            (resource) => !(resource.userId === userId && resource.resourceLevel === resourceLevel)
          );
          resourceList.push(userObjByType[resourceLevel](userId));
          reqTeam.resources = resourceList;
        }
      }
    }

    const areaObj = { id: reqArea.id, areaType: reqArea.areaType, teams: teamsMappedToArea, type: reqArea.type };
    if (areaObj.areaType === AREA_TYPE.DYNAMIC) {
      const structuredAreaDefinition = areaDefinitionHelper(reqArea);
      areaObj.areaDefinition = structuredAreaDefinition;
    }
    areaToBeUpdated.push(areaObj);
  });
  return areaToBeUpdated;
};

export const getTeamAndResorceObjectForAreas = (selectedUser, rawAreas, initialAreaTeamMapping) => {
  const { areaTeamMapping, id: userId } = selectedUser;
  const areasDict = _.keyBy(rawAreas, 'id');
  const areasToBeUpdatedForExistingMapping = updateResourcesForExistingAreaMapping({
    areaTeamMapping,
    areasDict,
    initialAreaTeamMapping,
    userId,
  });
  const { deleted: deletedAreaIds } = getMappedEntityChanges(
    Object.keys(areaTeamMapping || {}),
    Object.keys(initialAreaTeamMapping || {})
  );
  const areasToBeUpdatedForDeletedMapping = updateResourceForDeletedAreaMapping({
    deletedAreaIds,
    areasDict,
    initialAreaTeamMapping,
    userId,
  });
  return [...areasToBeUpdatedForExistingMapping, ...areasToBeUpdatedForDeletedMapping];
};
